import { Flex } from "antd"
import { Text } from "~/components/Text"
import styles from "./index.css"

export const ICPBlock = () => {
  const alternate = window.location.host === "kadateam.com"
  const name = alternate ? "咔嗒智能台" : "咔嗒爆"
  const icpCode = alternate ? "浙ICP备15024013号-16" : "浙ICP备15024013号-17"
  const safeCode = alternate ? "33010502012692" : "33010502013256"

  return (
    <Flex
      className={styles.footer}
      gap={20}
      align="center"
      justify="center"
    >
      <Text
        size="s"
        type="secondary"
      >
        {name}
      </Text>
      <a
        href="https://beian.miit.gov.cn/"
        rel="noreferrer"
        target="_blank"
      >
        <Text
          size="s"
          type="secondary"
        >
          ICP备案号：{icpCode}
        </Text>
      </a>
      <a
        href={`https://beian.mps.gov.cn/#/query/webSearch?code=${safeCode}`}
        rel="noreferrer"
        target="_blank"
      >
        <Text
          size="s"
          type="secondary"
        >
          浙公网安备{safeCode}号
        </Text>
      </a>
    </Flex>
  )
}
